import { useDispatch, useSelector } from 'react-redux';
import { ButtonGroup, FormControl, Grid, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import { PublicationSelector } from './PublicationSelector';
import { Heading } from './common/Heading';
import { useEffect } from 'react';
import { Playlist } from '../api/playlist';

function ToolBarGapAnalysisReport() {
  const dispatch = useDispatch();
  const { formatFilter } = useSelector((state: any) => state.report);

   const playlists: Playlist[] = [] // need implementation

  useEffect(() => {
    dispatch({ type: 'SET_FILTER_PLAYLISTS', payload: playlists[0]?.slug });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    dispatch({ type: 'SET_FILTER_PLAYLISTS', payload: event.target.value });
  };

  const handleFormatChange = (event: SelectChangeEvent) => {
    dispatch({ type: 'SET_FILTER_FORMAT', payload: event.target.value });
  };

  return (
    <Toolbar style={{ paddingBottom: '45px', paddingLeft: '15px' }}>
      <Grid container alignItems={'center'} justifyContent={'space-between'}>
        <Grid item>
          <Grid container alignItems={'center'} spacing={2}>
            <Grid item>
              <Heading>Playlist</Heading>
            </Grid>
            <Grid item>
              <ButtonGroup>
                <FormControl
                  variant="outlined"
                  margin="dense"
                  style={{
                    marginTop: '0px',
                    marginBottom: '0px',
                  }}
                >
                  <Select
                    id="playlist-select"
                    // defaultValue={playlists[0]?.slug}
                    onChange={handleChange}
                    sx={{
                      fontFamily: 'ProximaNovaBold',
                      textTransform: 'none',
                      color: '#000',
                      height: '43px',
                      width: '200px',
                      marginRight: '30px',
                    }}
                  >
                    {playlists.map((playlist: Playlist) => (
                      <MenuItem key={playlist.slug} value={playlist.slug}>
                        {playlist.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </ButtonGroup>
            </Grid>
            <Grid item>
              <Heading>Format</Heading>
            </Grid>
            <Grid item>
              <ButtonGroup>
                <FormControl
                  variant="outlined"
                  margin="dense"
                  style={{
                    marginTop: '0px',
                    marginBottom: '0px',
                  }}
                >
                  <Select
                    id="format-select"
                    value={formatFilter}
                    onChange={handleFormatChange}
                    sx={{
                      fontFamily: 'ProximaNovaBold',
                      textTransform: 'none',
                      color: '#000',
                      height: '43px',
                      width: '200px',
                      marginRight: '30px',
                    }}
                  >
                    {['horizontal', 'vertical'].map((format: string) => (
                      <MenuItem key={format} value={format}>
                        {format}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </ButtonGroup>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={2}>
          <PublicationSelector />
        </Grid>
      </Grid>
    </Toolbar>
  );
}

export default styled(ToolBarGapAnalysisReport)`
  margin-bottom: 40px;
`;
